import { Button } from 'components/lib';
import OverlayFooter from 'components/Overlays/OverlayFooter';
import OverlayHeader from 'components/Overlays/OverlayHeader';
import WideOverlayContainer from 'components/Overlays/WideOverlayContainer';
import React from 'react';
import { CreateRFI } from 'records/interactions/CreateRFI';
import RFIOverlayStatusBar from '../RFIOverlayStatusBar';
import OfficialQuestionSection from './OfficialQuestionSection';
import ProjectDetailsSection from './ProjectDetailsSection';
import RequestedBySection from './RequestedBySection';

interface Props {
  interaction: CreateRFI;
  onCancelClick: () => void;
  onToggleExpand: () => void;
  onCreateRFI: () => Promise<void>;
  onSaveDraft: () => Promise<void>;
  onDeleteDraft: (
    evt: React.MouseEvent<HTMLButtonElement>
  ) => void | Promise<void>;
  deleteDisabled: boolean;
  saveDisabled: boolean;
}

class WideCreateRFIOverlay extends React.Component<Props> {
  render(): React.ReactNode {
    const {
      interaction,
      saveDisabled,
      deleteDisabled,
      onCancelClick,
      onToggleExpand,
      onCreateRFI,
      onSaveDraft,
      onDeleteDraft,
    } = this.props;

    return (
      <WideOverlayContainer id="wide-create-rfi-overlay">
        <OverlayHeader
          id="create-rfi-overlay-header"
          title="New RFI"
          onCancelClick={onCancelClick}
          showExpand
          onToggleExpand={onToggleExpand}
          expanded
        />
        <div className="column" style={{ height: 'calc(100vh - 96px)' }}>
          <div className="row grow-1 justify-center oa">
            <div className="sections-wrapper row mt1">
              <div
                className="official-question-section-wrapper grow-1 mx3"
                style={{ maxWidth: '610px' }}
              >
                <OfficialQuestionSection interaction={interaction} />
              </div>
              <div className="bl-2" />
              <div className="shrink-0 ml3" style={{ width: '331px' }}>
                <div className="mr3">
                  <RFIOverlayStatusBar status="Draft" />
                  {/* RFI Preview goes here... */}
                  <RequestedBySection />
                  <ProjectDetailsSection interaction={interaction} />
                </div>
              </div>
            </div>
          </div>
          <div className="shrink-0">
            <OverlayFooter
              id="create-rfi-overlay-overlay-footer"
              confirmText="Send"
              onConfirmClick={onCreateRFI}
              confirmDisabled={saveDisabled}
              onCancelClick={onCancelClick}
              hideCancel={!deleteDisabled}
              hideSecondary={deleteDisabled}
              secondaryText="Save"
              secondaryDisabled={saveDisabled}
              onSecondaryClick={onSaveDraft}
            >
              {deleteDisabled ? (
                <Button
                  id="create-rfi-overlay-overlay-footer-save-draft-btn"
                  variant="secondary"
                  size="large"
                  disabled={saveDisabled}
                  onClick={onSaveDraft}
                >
                  Save
                </Button>
              ) : (
                <Button
                  id="create-rfi-overlay-overlay-footer-delete-draft-btn"
                  variant="destructive"
                  size="large"
                  disabled={deleteDisabled}
                  onClick={onDeleteDraft}
                >
                  Delete Draft
                </Button>
              )}
            </OverlayFooter>
          </div>
        </div>
      </WideOverlayContainer>
    );
  }
}

export default WideCreateRFIOverlay;
